import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
// import { Btn } from "../../styles/Button.styled"; // Твоя кастомна кнопка
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import styles from "../../styles/Docs/Docs.module.css";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  CONTACTS_RESET,
  getContacts,
  deleteContact,
} from "../../actions/contacts";
import { nameCompiler } from "../../helpers/nameCompiler";
import { Btn } from "../../styles/Button.styled";
import { CreateContactPopup } from "../Popup/CreateContactPopup";
import { RemoveBtn } from "../View/Infobar";
import { DotsLoader } from "../Loaders/Loader";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FilterTabs = styled.div`
  display: flex;
  gap: 8px;
`;

const Tab = styled.button<{ $active?: boolean }>`
  background: ${(props) => (props.$active ? "var(--white)" : "transparent")};
  color: ${(props) => (props.$active ? "var(--blue)" : "#64748b")};
  border: 1px solid ${(props) => (props.$active ? "var(--blue)" : "#cbd5e1")};
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: var(--sidebar-hover);
  }
`;

// const ActionBar = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   background: var(--background);
//   padding: 16px;
//   border-radius: 20px;
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
// `;

const ContactsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: var(--background);
  border-radius: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 16px;
`;

const ContactCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: var(--white);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
`;

const CompanyHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
  font-size: 14px;
`;

const EmailField = styled.div`
  color: #334155;
`;

const NameField = styled.div`
  color: #64748b;
`;

export function CompanyContacts() {
  const [activeTab, setActiveTab] = useState<
    "all" | "registered" | "unregistered"
  >("all");
  const [openPopupCreateContact, setOpenPopupCreateContact] = useState(false);

  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const contactsList = useAppSelector((state) => state.contactsList);

  useEffect(() => {
    if (contactsList.state === "idle") {
      dispatch(getContacts());
    }
  }, [dispatch, contactsList]);

  const handleDeleteContact = useCallback(
    (id: string) => {
      if (!id) return;
      dispatch(deleteContact(id) as any);
    },
    [dispatch],
  );

  const codeUser = user.company.code === "" ? user.login : user.company.code;
  const userName =
    user.company.code === "" ? nameCompiler(user) : user.company.title;

  return (
    <>
      <section className={`${styles.wrapper} ${styles.settings}`}>
        <div className={styles.bigLable}>
          Контакти компанії {codeUser} {userName}
        </div>

        <PageContainer>
         
            <Btn
              type="button"
              $width="200px"
              $color="var(--blue)"
              $marginTop="0"
              onClick={() => {
                setOpenPopupCreateContact(true);
              }}
              $background="var(--sidebar-hover)"
              $heightMobile="47px"
              $hoverColor="var(--background)"
            >
              Створити контакт
            </Btn>
         
          <FilterTabs>
            <Tab
              $active={activeTab === "all"}
              onClick={() => setActiveTab("all")}
            >
              Всі
            </Tab>
            <Tab
              $active={activeTab === "registered"}
              onClick={() => setActiveTab("registered")}
            >
              Зареєстровані компанії
            </Tab>
            <Tab
              $active={activeTab === "unregistered"}
              onClick={() => setActiveTab("unregistered")}
            >
              Незареєстровані компанії
            </Tab>
          </FilterTabs>

          <ContactsList>
            {contactsList.state === "loading" && !contactsList.list?.length && (
              <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <DotsLoader scale={0.6} />
              </div>
            )}
            {contactsList.list.map((group: any) => {
              const company = group.company;

              return group.accounts.map((account: any) => {
                const fullName = [
                  account.lastname,
                  account.firstname,
                  account.middlename,
                ]
                  .filter(Boolean)
                  .join(" ")
                  .trim();

                const companyTitle = company.code ? company.title : "";

                return (
                  <ContactCard key={account.id}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <CompanyHeader>
                        <CheckCircleOutlineIcon
                          sx={{ fontSize: 18, color: "var(--blue)" }}
                        />
                        <span>
                          {company.code ? company.code : account.code}
                        </span>
                        <span style={{ fontWeight: 400 }}>{companyTitle}</span>
                      </CompanyHeader>

                      <RemoveBtn
                        canDelete={true}
                        user={account}
                        canDeleteSigner={handleDeleteContact}
                      />
                    </div>

                    <InfoGrid>
                      <EmailField>
                        {account.email || "Не вказано email"}
                      </EmailField>
                      <NameField>
                        {fullName || "Представник (ПІБ відсутнє)"}
                      </NameField>
                    </InfoGrid>
                  </ContactCard>
                );
              });
            })}
          </ContactsList>
        </PageContainer>
      </section>

      {openPopupCreateContact && (
        <CreateContactPopup
          handleClose={() => setOpenPopupCreateContact(false)}
          onSuccess={() => {
            setOpenPopupCreateContact(false);
            dispatch({ type: CONTACTS_RESET });
          }}
        />
      )}
    </>
  );
}
